export default function Heading({
  children,
  level = 1,
  id,
}: {
  children: React.ReactNode;
  id?: string;
  level?: 1 | 2 | 3 | 4;
}) {
  switch (level) {
    case 4:
      return (
        <h4 id={id} className="font-bold text-slate-800">
          {children}
        </h4>
      );
    case 3:
      return (
        <h3 id={id} className="text-2xl font-bold text-slate-800">
          {children}
        </h3>
      );
    case 2:
      return (
        <h2 id={id} className="text-3xl font-bold text-slate-800">
          {children}
        </h2>
      );
    case 1:
    default:
      return (
        <h1 id={id} className="text-4xl font-bold text-slate-800">
          {children}
        </h1>
      );
  }
}
